import script from "./ftx-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ftx-dialog.vue?vue&type=script&setup=true&lang=js"

import "./ftx-dialog.vue?vue&type=style&index=0&id=337ed9a2&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QIcon,QInput,QForm,QScrollArea});qInstall(script, 'directives', {ClosePopup});
